import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PdfDownloadCard from './PdfDownloadCard';
import { Tab, TabsContainer } from '../../utils/SubjectTabs';

export default function SpecialNotes({ packId }) {
  const navigate = useNavigate();
  const [isPurchased, setIsPurchased] = useState(null);
  const [allNotes, setAllNotes] = useState(null);
  const [specialNotes, setSpecialNotes] = useState(null);
  const [subjects, setSubjects] = useState(null);
  const [currentSubject, setCurrentSubject] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const purchaseResponse = await axios.get(`/api/packs/${packId}/is-purchased`);
        const isPurchasedData = purchaseResponse?.data?.data?.isPurchased;
        if (!isPurchasedData) return;
        setIsPurchased(isPurchasedData);
        if (!isPurchasedData) return;
        const res = await axios.get(`/api/packs/${packId}/special-notes`);
        const response = res?.data?.data;
        if (response) {
          const currSubject = response?.subjects?.[0];
          setAllNotes(response?.specialNotes);
          setSpecialNotes(
            response?.specialNotes?.filter((item) => item.subject._id.toString() === currSubject?._id.toString()),
          );
          setSubjects(response?.subjects);
          setCurrentSubject(currSubject);
        }
      } catch (error) {}
    }
    fetchData();
  }, [packId]);

  const handleSubjectChange = (subject) => {
    setCurrentSubject(subject);
    const currNotes = allNotes?.filter((item) => item.subject._id.toString() === subject?._id.toString());
    setSpecialNotes(currNotes);
  };

  if (isPurchased === false) navigate('/v2/home');

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full overflow-x-auto">
        <TabsContainer color={currentSubject?.color}>
          {subjects?.map((tab) => (
            <Tab
              key={tab.title}
              isActive={currentSubject?.title === tab.title}
              color={currentSubject?.title === tab.title ? currentSubject?.color : 'var(--q3-neutral-light)'}
              tabColor={tab.color}
              bgColor="var(--q3-surface-dim)"
              onClick={() => handleSubjectChange(tab)}
            >
              {tab.icon && <img src={tab.icon} alt={tab.title} className="" />}
              <p className="mb-0">{tab.title}</p>
            </Tab>
          ))}
        </TabsContainer>
      </div>
      <div className="grid grid-cols-2 gap-5 py-5">
        {specialNotes &&
          specialNotes?.map((item) => (
            <PdfDownloadCard title={item.title} link={item.url} resourceType={'Special Notes'} />
          ))}
      </div>
    </div>
  );
}
